import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import Caption from 'LuxKit/Typography/Caption'
import { FormattedMessage } from 'react-intl'

interface Props {
  size?: 'small' | 'medium' | 'large'
}

function AccountAccessMarketingOptIn({ size = 'medium' }: Props) {
  return (
    <CheckboxInput
      name="marketingOptIn::boolean"
      value="true"
      data-testid="marketing-opt-in-checkbox"
      size={size}
    >
      <Caption colour="light-foreground-alt" variant="medium">
        <FormattedMessage
          id="Er5W5GI32LXAk5-rj8d4"
          defaultMessage="Yes, send me offers and travel inspiration by email. You can unsubscribe at any time."
          description="Optional unticked email marketing consent shown when cookie consent is required"
        />
      </Caption>
    </CheckboxInput>
  )
}

export default AccountAccessMarketingOptIn
